const tennants = {
	title: "Klienter",
	new_tennant: "Ny klient",
	edit_tennant: "Rediger klient",
	view_tennant: "Vis klient",
	list_title: "Klienter",
	list_subtitle: "Håndter klienter",
	create_title: "Opprett ny klient",
	update_title: "Oppdater klient",
	address_title: "Adresse",
	details_title: "Klient detaljer",
	database_title: "Database detaljer",
	id: "ID",
	subdomain: "Subdomene",
	tenant_company: "Klient selskap",
	dbname: "Database Navn",
	master_username: "Master Brukernavn",
	master_password: "Master Passord",
	email: "Epost",
	first_name: "Fornavn",
	last_name: "Etternavn",
	mobile: "Mobil",
	status: "Status",
	type: "Type",
	active_from: "Aktiv fra",
	inactive_from: "Inaktiv fra",
	payed_for_users: "Antall brukere",
	no_active_users: "Aktive brukere",
	setup: "Oppsett",
	run_migration: "Kjør DB Migrering",
	run_migration_short: "Migrer",
	db_migration_success: "Database er blitt migrert",
	confirm_text: "Skriv inn navn på subdomene du vil slette.",
	confirm_text_not_match: "Subdomene samsvarer ikke",
	activate_now_later: "Vil du aktivere klient nå eller senere?",
	btn_now: "Nå",
	btn_later: "Senere",
	sms_service: "SMS Service Status",
	last_migrated_at: "Sist migrert",
	help_tenant_database: "Data i denne seksjonen genereres automatisk.",
	select_tenant_type_first: "Velg klient type",
	tenant_migration_warning: "Klienter vil bli oppdatert. Vil du fortsette?",
	course_id_increment_start: "Kursnummer start",
	course_id_increment_start_helptext: "Sett startnummer for kurs id. Kan ikke endres etter klientopprettelse",
	connection_name: "Tilkoblingsnavn",
	tenant_vat_number: "Klient orgnummer",
	notif_email_from: "Epost varsling avsender",
	notif_sms_from: "SMS varsling avsender",
	swagger_token: "Swagger Token",
	checklist_status: "Checklists status",
	notif_email_not_verified: "Epost er ikke verifisert.",
	notif_email_verified: "Verifisert",
	resend_verify: "Resend/Verify",
};
export default tennants;